import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { success } from 'plugins/toastr';
import { fetchMemoIfNeeded, saveMemo } from 'memo/actions/memo';
import PageLoader from 'common/components/PageLoader';
import ResourceCard from 'common/components/ResourceCard';
import YoutubeVideo from 'common/components/YoutubeVideo';
import MemoDetailHeader from 'memo/components/MemoDetailHeader';
import MemoForm from 'memo/components/MemoForm';

const ReceiveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de chargement</div>
    <p>Une erreur est survenue pendant le chargement de l'astuce technique.</p>
  </div>
);

const SaveError = () => (
  <div className="ui negative message">
    <div className="header">Erreur de sauvegarde</div>
    <p>Une erreur est survenue pendant la sauvegarde du mémo technique.</p>
  </div>
);

const mapStateToProps = state => {
  const { memo } = state.memos;
  const { memo: current, ...rest } = memo;

  return {
    current,
    ...rest,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchMemo: () => dispatch(fetchMemoIfNeeded(ownProps.route.memo)),
  saveMemo: (page, fields) =>
    dispatch(saveMemo(ownProps.route.memo, page, fields)),
});
class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    isFetching: PropTypes.bool,
    receiveError: PropTypes.object,
    saveError: PropTypes.object,
    current: PropTypes.object,
    route: PropTypes.object.isRequired,
    fetchMemo: PropTypes.func.isRequired,
    saveMemo: PropTypes.func.isRequired,
  };

  static contextTypes = {
    data: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.page = context.data.page;

    this.onSubmitMemo = this.onSubmitMemo.bind(this);
    this.onSaveMemo = this.onSaveMemo.bind(this);
  }

  componentWillMount() {
    this.props.fetchMemo();
  }

  onSubmitMemo(fields) {
    const { image, video } = this.refs;

    this.props
      .saveMemo(this.page, {
        image: image.getResource(),
        image_id: image.getValue(),
        video: video.getValue(),
        ...fields,
      })
      .then(() => success('Astuce technique mise à jour avec succès'));
  }

  onSaveMemo() {
    // Submitting manually
    this.refs.form.submit();
  }

  render() {
    const {
      current,
      isFetching,
      receiveError,
      saveError,
      children,
    } = this.props;

    if (receiveError) {
      return <ReceiveError />;
    }

    if (saveError) {
      return <SaveError />;
    }

    if (isFetching || !current) {
      return <PageLoader title={"Chargement de l'astuce technique"} />;
    }

    const video = current.video ? current.video.original : null;

    return (
      <div>
        <MemoDetailHeader
          memo={current}
          page={this.page}
          save={this.onSaveMemo}
        />
        <div className="ui bottom attached segment">
          <div className="ui grid">
            <div className="four wide column">
              <ResourceCard
                ref="image"
                name="image"
                title="Image"
                resource={current.image}
              />
            </div>
            <div className="twelve wide column">
              <MemoForm ref="form" onSubmit={this.onSubmitMemo} />
            </div>
          </div>
          <div className="ui divider" />
          <form className="ui form">
            <YoutubeVideo
              ref="video"
              name="video_url"
              title="URL vidéo Youtube"
              value={video}
            />
          </form>
        </div>
        {children}
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  CoreLayout
);



// WEBPACK FOOTER //
// ./src/modules/memo/layouts/CoreLayout.js